/**
 * Custom JS - Love Wholeshop
 * Handles desktop navigation hover & clickable parent menu items.
 */

(function () {
  'use strict';

  function initHeaderMenuNavigation() {
    const isDesktop = () => window.innerWidth >= 990;
    const headerMenus = document.querySelectorAll('header-menu');

    headerMenus.forEach((headerMenu) => {
      const mainDetails = headerMenu.querySelector('details');
      if (!mainDetails) return;

      const summary = mainDetails.querySelector('summary');
      const anchor = summary ? summary.querySelector('.header__menu-item-anchor') : null;

      // 1. Desktop Hover: Open on mouseenter, close on mouseleave
      let hoverTimeout;

      headerMenu.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(hoverTimeout);
        mainDetails.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      headerMenu.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        hoverTimeout = setTimeout(() => {
          mainDetails.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 120);
      });

      // 2. Click Handling on Parent Summary
      if (summary) {
        summary.addEventListener('click', (event) => {
          // If clicked specifically on the caret icon or its SVG, allow toggle behavior
          const clickedCaret = event.target.closest('.icon-caret') || (event.target.tagName && event.target.tagName.toLowerCase() === 'svg');
          if (clickedCaret) {
            return; // Let default summary toggle happen
          }

          // If clicked on or inside anchor, anchor's href takes user to page
          const targetAnchor = event.target.closest('.header__menu-item-anchor');
          const targetUrl = targetAnchor ? targetAnchor.getAttribute('href') : summary.dataset.url;

          if (targetUrl && targetUrl !== '#' && targetUrl !== '') {
            // Check for new tab keys (Ctrl, Cmd, Middle click)
            if (event.ctrlKey || event.metaKey || event.button === 1) {
              return; // Browser opens new tab
            }

            event.preventDefault();
            event.stopPropagation();
            window.location.href = targetUrl;
          }
        });
      }

      // 3. Submenu nested items (level 2 with level 3 dropdowns)
      const subDetailsList = mainDetails.querySelectorAll('details[id^="Details-HeaderSubMenu"]');
      subDetailsList.forEach((subDetails) => {
        const subSummary = subDetails.querySelector('summary');
        let subTimeout;

        subDetails.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          clearTimeout(subTimeout);
          subDetails.setAttribute('open', '');
          if (subSummary) subSummary.setAttribute('aria-expanded', 'true');
        });

        subDetails.addEventListener('mouseleave', () => {
          if (!isDesktop()) return;
          subTimeout = setTimeout(() => {
            subDetails.removeAttribute('open');
            if (subSummary) subSummary.setAttribute('aria-expanded', 'false');
          }, 120);
        });

        if (subSummary) {
          subSummary.addEventListener('click', (event) => {
            const clickedCaret = event.target.closest('.icon-caret') || (event.target.tagName && event.target.tagName.toLowerCase() === 'svg');
            if (clickedCaret) {
              return;
            }

            const targetAnchor = event.target.closest('.header__menu-item-anchor');
            const targetUrl = targetAnchor ? targetAnchor.getAttribute('href') : subSummary.dataset.url;

            if (targetUrl && targetUrl !== '#' && targetUrl !== '') {
              if (event.ctrlKey || event.metaKey || event.button === 1) {
                return;
              }
              event.preventDefault();
              event.stopPropagation();
              window.location.href = targetUrl;
            }
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initHeaderMenuNavigation();
      initCartDrawerMoq();
    });
  } else {
    initHeaderMenuNavigation();
    initCartDrawerMoq();
  }

  function initCartDrawerMoq() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // Intercept minus button on items under 200 when quantity is 2
    drawer.addEventListener('click', (event) => {
      const minusBtn = event.target.closest(".quantity__button[name='minus']");
      if (!minusBtn) return;

      const qtyInput = minusBtn.closest('quantity-input');
      if (!qtyInput || qtyInput.dataset.isUnder200 !== 'true') return;

      const input = qtyInput.querySelector('.quantity__input');
      if (!input) return;

      const val = parseInt(input.value) || 0;
      if (val <= 2) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        minusBtn.classList.add('disabled');
        minusBtn.setAttribute('aria-disabled', 'true');
      }
    }, true);

    // Sync button states on items under 200
    function checkDrawerItems() {
      const under200Inputs = drawer.querySelectorAll('quantity-input[data-is-under-200="true"]');
      under200Inputs.forEach((qi) => {
        const inp = qi.querySelector('.quantity__input');
        const minusBtn = qi.querySelector(".quantity__button[name='minus']");
        if (!inp) return;

        const val = parseInt(inp.value) || 0;
        if (minusBtn) {
          if (val <= 2) {
            minusBtn.classList.add('disabled');
            minusBtn.setAttribute('aria-disabled', 'true');
            minusBtn.style.opacity = '0.3';
            minusBtn.style.cursor = 'not-allowed';
          } else {
            minusBtn.classList.remove('disabled');
            minusBtn.removeAttribute('aria-disabled');
            minusBtn.style.opacity = '1';
            minusBtn.style.cursor = 'pointer';
          }
        }
      });
    }

    checkDrawerItems();

    const observer = new MutationObserver(checkDrawerItems);
    observer.observe(drawer, { childList: true, subtree: true });
  }

  // Support Shopify Theme Editor re-rendering
  document.addEventListener('shopify:section:load', () => {
    initHeaderMenuNavigation();
    initCartDrawerMoq();
  });
})();

